<template>
  <LoadingWrapper :state="status">
    <FullScreenLayoutContent :full-width="false">
      <template #header>
        <div class="flex items-center p-4">
          <BackButton backup-route-name="coachees" />
        </div>
      </template>
      <AddCoacheesWizzard :feedback-topics="data.feedbackTopics" />
    </FullScreenLayoutContent>
  </LoadingWrapper>
</template>
<script lang="ts" setup>
import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
import AddCoacheesWizzard from './AddCoacheesWizzard.vue'
import { useCompleteFeedbackTopics } from '../../../core/composables/use-complete-feedback-topics'
import BackButton from '@/core/components/BackButton.vue'
import FullScreenLayoutContent from '@/core/components/layouts/FullScreenLayoutContent.vue'

const { status, data } = useCompleteFeedbackTopics()
</script>
